import request from "@/utils/request";

// 获取区域列表
export function getAreaList(params) {
  return request.post("/ext/ac/vrr/getAreaList", { params });
}


// 获取预约列表
export function getOrderList(params) {
  return request.get("/truckOrder/history", { params });
}
// 创建车辆预约信息
export function createManOrderInfo(data) {
  return request.post("/personOrder/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 创建访客预约信息
export function createManOrder(data) {
  return request.post("/ext/ac/vrr/saveRecord", data);
}

// 创建货车预约信息
export function createTruckOrderInfo(data) {
  return request.post("/truckOrder/create", data);
}

// 创建车辆预约信息
export function createCarOrderInfo(data) {
  return request.post("/carOrderRecord/create", data);
}

// 获取预约列表
export function getManOrderList(params) {
  return request.get("/personOrder/history", { params });
}

// 获取访问列表
export function getManAccessList(params) {
  return request.get("/personAccess/history", { params });
}

// 获取预约列表
export function getTruckOrderList(params) {
  return request.get("/truckOrder/history", { params });
}

// 获取访问列表
export function getTruckAccessList(params) {
  return request.get("/truckAccess/history", { params });
}

// 获取过磅列表
export function getWeighBridgeList(params) {
  return request.get("/weighbridge/history", { params });
}

// 获取灌料列表
export function getMaterialCheckList(params) {
  return request.get("/dualCheck/history", { params });
}

// 获取消息推送列表
export function getProjectConfigList(data) {
  return request.get("/projectConfig/list");
}

// 获取货车道闸列表
export function getAggregateTruckStay(data) {
  return request.get("/truckAccess/exitCar");
}

// 免登录，创建车辆预约信息

export function extCreateCarOrderInfo(data) {
  return request.post("/ext/carOrderRecord/create", data);
}
// 免登录，创建人员预约信息
export function extCreateManOrderInfo(data) {
  return request.post("/ext/personOrder/create", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

// 获取最后一条过磅数据，type 1 = 毛重，type 2 = 皮重
export function getLastWeight(type) {
  return request.get("/weighbridge/getLastWeight/" + type);
}
// 提交自助过磅的信息
export function autoByWeight(type, data) {
  return request.post("/weighbridge/autoByWeight/" + type, data);
}
